import { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { useSelector } from 'react-redux';
import { blue, lightBlue } from '@mui/material/colors';

import './SCUIContent.scss';
import { Shadows } from '@mui/material/styles/shadows';
import React from 'react';

interface IProps {
    headerName?: string;
    children: React.ReactNode;
    className?: string;
}

export const SCUIContent: FC<IProps> = ({ headerName = null, children, className = '' }) => {
    const { i18n } = useTranslation();

    useEffect(() => {
        document.body.dir = i18n.dir();
    }, [i18n.dir()]);

    const darkModeStore: any = useSelector((state: any) => state?.darkMode);
    const menuStore: any = useSelector((state: any) => state?.menu);
    const [darkState, setDarkState] = useState(darkModeStore?.isDarkMode);
    const palletType = darkState ? 'dark' : 'light';
    const mainPrimaryColor = darkState ? blue[500] : lightBlue[500];
    const backgroundColor = darkState ? '#000' : '#f5f5f5';
    const darkTheme = createTheme({
        shadows: Array(25).fill('none') as Shadows,
        components: {
            MuiOutlinedInput: {
                styleOverrides: {
                    root: {
                        backgroundColor: darkState ? '#111' : '#fff',
                    },
                },
            },
        },
        typography: {
            fontFamily: `Nunito`,
            fontSize: 14,
            fontWeightLight: 300,
            fontWeightRegular: 400,
            fontWeightMedium: 500,
        },
        palette: {
            mode: palletType,
            background: {
                default: backgroundColor,
            },
            primary: {
                main: mainPrimaryColor,
            },
        },
    });

    useEffect(() => {
        setDarkState(darkModeStore?.isDarkMode);
    }, [darkModeStore?.isDarkMode]);

    return (
        <ThemeProvider theme={{ ...darkTheme, direction: i18n.dir('en-US') }}>
            <CssBaseline />
            <div
                className={
                    className +
                    (darkState ? '  darkMode' : ' lightMode') +
                    (menuStore?.isMenuOpen ? ' menuOpened' : ' menuClosed')
                }
                style={{ paddingTop: '2rem' }}
                id="scuiContent"
            >
                {headerName !== null && (
                    <div className="header-area">
                        <h4 className="txt-header"> {headerName}</h4>
                    </div>
                )}
                {children}
            </div>
        </ThemeProvider>
    );
};
